import { PLAN_TYPES, PRICING } from "../constants/subscriptionPricing";

const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export function formatCurrency(amount) {
  return currencyFormatter.format(amount);
}

export function formatPlanLabel(planType) {
  if (planType === PLAN_TYPES.WITH_EHR) {
    return "Monthly with EHR — $129.99/mo";
  }
  return "Monthly without EHR — $89.99/mo";
}

export function formatSeatRoleLabel(role) {
  if (role === "nurse_practitioner") return "Nurse Practitioner";
  if (role === "back_office") return "Back Office Staff";
  return "Supporting User";
}

export function addMonths(date, months) {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
}

export function getRenewalDate(startDate = new Date()) {
  return addMonths(startDate, 1);
}

export function formatDisplayDate(date) {
  const value = date instanceof Date ? date : new Date(date);
  return value.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function getBasePlanPrice(planType) {
  if (planType === PLAN_TYPES.WITH_EHR) return PRICING.with_ehr;
  return PRICING.without_ehr;
}

export function calculateBillingSummary({ planType, seats = [] }) {
  const basePrice = getBasePlanPrice(planType);
  const seatCount = seats.length;
  const seatTotal = seatCount * PRICING.seatPerMonth;
  const total = basePrice + seatTotal;

  const lineItems = [
    {
      id: "base",
      label:
        planType === PLAN_TYPES.WITH_EHR
          ? "Monthly subscription with EHR"
          : "Monthly subscription without EHR",
      amount: basePrice,
    },
  ];

  seats.forEach((seat) => {
    lineItems.push({
      id: seat.id,
      label: `${formatSeatRoleLabel(seat.role)} seat — ${seat.email}`,
      amount: PRICING.seatPerMonth,
    });
  });

  return {
    lineItems,
    baseTotal: basePrice,
    seatTotal,
    total,
    billingLabel: `${formatCurrency(total)}/month`,
    billingPeriod: "monthly",
  };
}

export function createInitialSubscription() {
  const startDate = addMonths(new Date(), -1);
  const renewalDate = new Date();
  renewalDate.setDate(renewalDate.getDate() + 5);

  return {
    planType: PLAN_TYPES.WITHOUT_EHR,
    startDate: startDate.toISOString(),
    renewalDate: renewalDate.toISOString(),
  };
}

export function createInitialSeats() {
  return [
    {
      id: "seat-np-1",
      email: "np.support@example.com",
      role: "nurse_practitioner",
      invitedAt: addMonths(new Date(), -2).toISOString(),
    },
  ];
}

export function getCheckoutLineAmount(lineItem) {
  return lineItem.amount;
}
